import React from 'react'

import { ThemeProvider } from '@material-ui/core/styles'

import { MATERIAL_THEME } from './src/styles/themes'

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={MATERIAL_THEME}>{element}</ThemeProvider>
)
